import { TimeZoneDisplay } from "@models/Sensor/TimeZone.model";
import { ImportFeed } from "./importSchedule.model";

export class ImportDataCriteria {
    thingId: string;
    refId: string;
    thingName: string;
    details: string;
    thingKey: string;
    thingSecret: string;
    dataSource: string;
    startDate: string;
    endDate: string;
    dataTypes: string[];
    timeStampParm: string;
    feed: number;
    latitudeDaily: number;
    longitudeDaily: number;
    radiusDaily: number;
    timeZoneDisplay: TimeZoneDisplay;
    timeZoneOffset: number;
}

export enum WPCrop {
    corn = "corn",
    soy = "soy",
    sunflower = "sunflower",
    canola = "canola",
    cotton = "cotton",
    millet = "millet",
    rice = "rice",
    sorghum = "sorghum",
    wheat = "wheat",
    alfalfa = "alfalfa"
}